import CryptoJS from 'crypto-js'

const key = process.env.REACT_APP_SECRET_KEY

const SecureStorage = {}
SecureStorage.encrypt = (data) => {
	data = CryptoJS.AES.encrypt(data, key)
	return data.toString()
}

SecureStorage.decrypt = (data) => {
	const bytes = CryptoJS.AES.decrypt(data, key)
 	try {
		const plainText = bytes ? bytes.toString(CryptoJS.enc.Utf8) : ''
		return plainText.toString()
	} catch (error) {
		return ''
	}
}

export default SecureStorage



// WEBPACK FOOTER //
// ./src/utils/encrypt.js